import styled from 'styled-components';

import { TestStatusType } from './TestCard.types';

const indicatorColors: Partial<Record<TestStatusType, string>> = {
	idle: '#768d95',
	pending: '#768d95',
	success: '#83bd41',
	error: '#dc360c',
	timeout: '#dc360c',
};

export const StyledTestCard = styled('div')`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
`;

export const TestCardIndicator = styled('div')<{ status: TestStatusType }>`
	width: 10px;
	height: 10px;
	border-radius: 100%;
	margin-right: 8px;
	background-color: ${({ status }) => indicatorColors[status]};
`;

export const TestCardMessage = styled('div')`
	display: flex;
	align-items: center;

	& > *:not(:first-child) {
		flex: 1;
	}
`;

export const TestCardFooter = styled('div')`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 16px 0;

	& > *:first-child {
		flex: 1;
		padding: 0 24px 0 0;
	}
`;
